/* eslint-disable */
import template from "./similarToursSelect.html"
import "./similarToursSelect.scss"
import {extendDecorator, viewModelDecorator} from "@/js/common/Domain/Service/mixins/decorators";
import SimilarToursSelect from "@/js/common/components/similarTourSelect/SimilarToursSelect";
import SimilarTourDesktop from "./components/similarTour/SimilarTourDesktop";

@viewModelDecorator({
	defaults: {
		open: false
	}
})
@extendDecorator({
	template,
	itemView: SimilarTourDesktop,
	bindings: {
		".js-similar-collection": "collection:$collection",
		".similarToursSelect__list": "classes: {open: open}",
		".similarToursSelect__loader": "toggle:not(equal(loadingState, 'finished'))"
	},
	events: {
		"click .similarToursSelect__label": "toggleList"
	}
})
export default class SimilarToursSelectDesktop extends SimilarToursSelect {
	initialize({controllerModel, gotoTourPage, ages}) {
		super.initialize();
		this.gotoTourPage = gotoTourPage;
		this.viewModel.mapState("loadingState", controllerModel);
		this.initDOMEvents();
	}

	initDOMEvents() {
		$(document).on("click", (e) => {
			if (!$(e.target).closest(this.$el).length) {
				this.viewModel.set({open: false});
			}
		})
	}

	toggleList() {
		this.viewModel.set({
			open: !this.viewModel.get("open")
		})
	}
}